import { z } from 'zod'

// Mirrors CreateRecommendationDto. build_portfolio is included (unlike createCaseSchema's
// service-type enum) — recommending the one service an investor doesn't have yet is exactly this
// feature's point.
export const createRecommendationSchema = z.object({
  serviceType: z.enum(['portfolio_audit', 'trades_audit', 'build_portfolio']),
  reason: z.string().min(3, "Say why you're recommending this."),
})
export type CreateRecommendationFormValues = z.infer<typeof createRecommendationSchema>
